import http from './http'
import { AxiosPromise } from 'axios'
import { AppApiResponseData } from '../types/api'
import { EstimatedA1C, SystemHealthEvents } from '../types/systemEvent'

export function get(
	patientID: string,
	startTime: number,
	endTime: number,
	eventType?: string,
	foodImage?: boolean
): AxiosPromise<AppApiResponseData<Array<SystemHealthEvents>>> {
	let url = `/dario/${patientID}/events?start_time=@${startTime}&end_time=@${endTime}`

	if (eventType) {
		url = `${url}&event_type=${eventType}`
	}

	if (foodImage && eventType) {
		url = `${url}&event_type=${eventType}&food_image=${foodImage}`
	}

	if (foodImage && !eventType) {
		url = `${url}&food_image=${foodImage}`
	}

	return http({
		method: 'GET',
		url,
	})
}

export function getEstimatedA1C(
	patientID: string
): AxiosPromise<AppApiResponseData<EstimatedA1C>> {
	return http({
		method: 'GET',
		url: `/dario/${patientID}/events/estimatedA1C`,
	})
}

export function getMSKEvents(
	patientID: string,
	startTime: number,
	endTime: number
): AxiosPromise<AppApiResponseData<Array<any>>> {
	return http({
		method: 'GET',
		url: `/msk/user/${patientID}/playlist?start_time=${startTime}&end_time=${endTime}`,
	})
}
